/**
 * Created by alex.y on 7/31/2017.
 */
export enum LocationType {
    "Ship From" = 1,
    "Ship To" = 2,
    "Border Crossing" = 3,
    "Billing Address" = 4,
    "Country Of Origin" = 5
}


// WEBPACK FOOTER //
// ./app/objects/management/locationManagement/locationType.ts